<template>
    <div>
        <div class="topbar">
            <enterprises-header></enterprises-header>

            <div class="topbar__inner">
                <div class="topbar__key">
                    <header class="topbar__key__header">
                        Show
                        <select v-if="totalRowsCount >= 25" class="topbar__key__select" v-model="pageLength">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                        <template v-else>{{totalRowsCount}}</template>
                        of {{totalRowsCount}}
                        enterprises
                    </header>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper overflow-auto">
            <div class="main-table">
                <Grid
                    :columns="columns"
                    :data="connections"
                    :addCellData="addCellData"
                    :page-length="parseInt(pageLength)"
                    :total-rows-count="totalRowsCount"
                    :sort="sort"
                    :currentPage="currentPage"
                    v-on:changePage="changePage"
                    v-on:changeSort="changeSort"
                    v-on:action="gridAction"
                >
                </Grid>
            </div>
        </div>

        <add-connection
            ref="addEnterprise"
        >
        </add-connection>

    </div>
</template>

<script>
import grid from "@/mixins/grid";
import enterprises from "@/services/ecosystem/enterprises.service";
import Grid from "@/components/Grid";
import EnterprisesHeader from "@/views/ecosystem/EnterprisesHeader";
import addConnection from "@/components/connections/AddEnterpriseConnection";

export default {
    mixins: [grid],

    components: {
        Grid,
        EnterprisesHeader,
        addConnection,
    },

    data() {
        return {
            connections: [],

            columns: [
                {
                    label: 'Name',
                    name: 'name',
                    component: 'SearchCompanyNameColumn',
                },
                {
                    label: 'Description',
                    name: 'description',
                },
                {
                    label: 'Category',
                    name: 'categoriesStr',
                },
                {
                    label: 'Location',
                    name: 'location',
                },
                {
                    name: 'actions',
                    label: 'Actions',
                    component: 'Actions',
                },
            ],

            addCellData: {
                companyType: "enterprises",
            },
        }
    },

    mounted() {
        this.getList()

        this.$store.watch(state => {
            if (state.needUpdateEnterprises) {
                this.getList()
            }
        })
    },

    methods: {
        getList() {
            let columns = this.arrayHelper.arrayColumn(this.columns, 'name')
            let currentPage = this.currentPage
            let pageLength = this.pageLength
            let sort = this.sort

            enterprises.getEnterprises({columns, sort, currentPage, pageLength}).then(response => {
                this.connections = response.data.data
                this.totalRowsCount = parseInt(response.data.total_count)
                this.currentPage = response.data.current_page
            })
        },

        addEnterprise() {
            this.$store.commit('setAddEnterprise', true);
            this.$nextTick(() => {
                this.$store.commit('setAddEnterprise', false);
            })
        },

        gridAction(params) {
            if (params.action == 'connect') {
                this.$refs.addEnterprise.open(params.rowId)
            }
        },
    }
}
</script>

<style scoped>

</style>